<template>
  <v-expansion-panels :disabled="use_tcp" :value="use_tcp ? undefined : saasXmlMenuOpened ? 0 : undefined" readonly >
    <v-expansion-panel test-tag="tag-313" @click="!any_loading ? saasXmlMenuOpened = !saasXmlMenuOpened : ''" :title="use_tcp ? $t('Чтобы использовать SaaS XML, отключите режим разработчика.') : ''" >
      <v-expansion-panel-header hide-actions>
        <v-switch test-tag="tag-317"
          v-model="saasXmlMenuOpened"
          @click.stop
          :label="$t('R-Keeper модуль XML-интерфейс для Приложения')"
          :loading="any_loading"
          :disabled="use_tcp"
          outlined
          dense
          filled
        ></v-switch>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider></v-divider>
        <v-container fluid>
          <div class="app-settings-table rk-license-mode">
            <div class="app-setting-row" :class="{ 'app-setting-row--disabled': disabled }">
              <div>
                <div class="app-setting-row__label-row">
                  <v-tooltip top max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        class="app-setting-row__hint-icon"
                      >
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span v-html="$t('Способ подключения XML-лицензии в r_keeper. Изменение применится после нажатия «Сохранить и проверить».')" />
                  </v-tooltip>
                  <div class="app-setting-row__label">{{ $t('Тип лицензии') }}</div>
                </div>
              </div>
              <v-select test-tag="tag-311"
                v-model="local_config.use_saas"
                :items="licenseModeItems"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                :disabled="any_loading"
                class="app-setting-field-license-type"
                :menu-props="{ contentClass: 'app-setting-field-menu rk-license-mode__menu' }"
                @change="(v) => $emit('useSaasChanged', v)"
              >
                <template v-slot:selection="{ item }">
                  <span class="rk-license-mode__selection">
                    {{ item.text }}
                  </span>
                </template>
              </v-select>
            </div>
            <div class="app-settings-table__section">
              <div class="rk-license-mode__content">
                <div class="rk-panel-content" v-show="!local_config.use_saas">
                  <div class="section-card">
                    <div class="section-header">
                      <v-icon class="section-icon">mdi-book-open-page-variant</v-icon>
                      <span class="section-title">{{ $t('Подключение лицензии') }}</span>
                    </div>
                    <ol class="lifetime-steps">
                      <li v-html="$t('Заказать лицензию на l.ucs.ru')" />
                      <li>{{ $t('Сгенерировать в карточке ресторана на l.ucs.ru') }}</li>
                      <li>{{ $t('Указать в свойствах ресторана') }}</li>
                    </ol>
                    <v-expansion-panels flat class="example-panel mt-3">
                      <v-expansion-panel test-tag="tag-314">
                        <v-expansion-panel-header hide-actions class="example-panel-header">
                          <span class="example-panel-label">{{ $t('Смотреть пример') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div
                            class="image-preview"
                            role="button"
                            tabindex="0"
                            @click="openViewer"
                            @keyup.enter="openViewer"
                          >
                            <v-img src="/rkeeper.png" contain max-height="480" class="image-thumb" />
                            <div class="image-preview-hint">
                              <v-icon small color="white">mdi-magnify-plus-outline</v-icon>
                            </div>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>

                  <v-dialog
                    v-model="viewerOpen"
                    fullscreen
                    hide-overlay
                    transition="fade-transition"
                    content-class="image-viewer-dialog"
                    @keydown.esc="closeViewer"
                  >
                    <div class="image-viewer">
                      <div class="viewer-toolbar">
                        <v-btn test-tag="tag-302" icon dark @click="zoomOut" :disabled="zoom <= minZoom">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                        <span class="viewer-zoom-label">{{ Math.round(zoom * 100) }}%</span>
                        <v-btn test-tag="tag-303" icon dark @click="zoomIn" :disabled="zoom >= maxZoom">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn test-tag="tag-304" icon dark @click="resetView">
                          <v-icon>mdi-fit-to-screen-outline</v-icon>
                        </v-btn>
                        <v-spacer />
                        <v-btn test-tag="tag-305" icon dark @click="closeViewer">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                      <div
                        class="viewer-canvas"
                        :class="{ 'viewer-canvas--zoomed': zoom > 1 }"
                        @wheel.prevent="onWheel"
                        @mousedown="startPan"
                        @mousemove="onPan"
                        @mouseup="endPan"
                        @mouseleave="endPan"
                        @touchstart.prevent="startTouch"
                        @touchmove.prevent="onTouch"
                        @touchend="endPan"
                      >
                        <img
                          src="/rkeeper.png"
                          alt="r_keeper example"
                          class="viewer-image"
                          :class="{ 'viewer-image--dragging': dragging }"
                          :style="imageStyle"
                          draggable="false"
                        />
                      </div>
                    </div>
                  </v-dialog>
                </div>

                <div class="rk-panel-content" v-show="local_config.use_saas">
                  <v-row dense class="saas-layout-row">
                    <v-col cols="12" lg="7" class="saas-layout-col">
                      <div class="rk-saas-settings__form">
                        <div class="app-settings-server-section-title">
                          {{ $t('Параметры SaaS XML лицензии') }}
                        </div>

                        <v-form :disabled="any_loading" ref="saasSettings" @submit.prevent="saveCredentials">
                          <div class="app-setting-row" :class="{ 'app-setting-row--disabled': disabled }">
                            <div class="app-setting-row__info">
                              <div class="app-setting-row__label-row">
                                <v-tooltip top max-width="320">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      class="app-setting-row__hint-icon"
                                    >
                                      mdi-help-circle-outline
                                    </v-icon>
                                  </template>
                                  <template>{{ $t('Логин (email) дилерской учетной записи на l.ucs.ru. Используется для получения данных об активной SaaS XML лицензии') }}</template>
                                </v-tooltip>
                                <div class="app-setting-row__label">{{ dealerUserLabel }}</div>
                              </div>
                            </div>
                            <div class="app-setting-row__control">
                              <v-text-field test-tag="tag-309"
                                v-model="user"
                                outlined
                                dense
                                hide-details
                                :disabled="any_loading"
                                class="app-setting-field--outlined"
                                :placeholder="dealerCredentialsPlaceholder"
                              />
                            </div>
                          </div>
                          <div class="app-setting-row" :class="{ 'app-setting-row--disabled': disabled }">
                            <div class="app-setting-row__info">
                              <div class="app-setting-row__label-row">
                                <v-tooltip top max-width="320">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      class="app-setting-row__hint-icon"
                                    >
                                      mdi-help-circle-outline
                                    </v-icon>
                                  </template>
                                  <template>{{ $t('Пароль дилерской учетной записи на l.ucs.ru. Не сохраняется в ПО в явном виде') }}</template>
                                </v-tooltip>
                                <div class="app-setting-row__label">{{ dealerPassLabel }}</div>
                              </div>
                            </div>
                            <div class="app-setting-row__control">
                              <v-text-field test-tag="tag-310"
                                v-model="password"
                                outlined
                                dense
                                hide-details
                                :disabled="any_loading"
                                class="app-setting-field--outlined"
                                :append-icon="showpwd ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showpwd ? 'text' : 'password'"
                                :placeholder="dealerCredentialsPlaceholder"
                                @click:append="showpwd = !showpwd"
                              />
                            </div>
                          </div>
                          <div class="app-setting-row" :class="{ 'app-setting-row--disabled': disabled }">
                            <div class="app-setting-row__info">
                              <div class="app-setting-row__label-row">
                                <v-tooltip top max-width="320">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      class="app-setting-row__hint-icon"
                                    >
                                      mdi-help-circle-outline
                                    </v-icon>
                                  </template>
                                  <span v-html="$t('Должен совпадать с тем, что был указан в заявке на SaaS XML лицензию')" />
                                </v-tooltip>
                                <div class="app-setting-row__label">{{ $t('Период XML лицензии') }}</div>
                              </div>
                            </div>
                            <div class="app-setting-row__control">
                              <v-select test-tag="tag-312"
                                v-model="product_guid"
                                :items="saas_xml_types"
                                item-text="text"
                                item-value="value"
                                outlined
                                dense
                                hide-details
                                :disabled="any_loading"
                                class="app-setting-field--outlined rk-saas-settings__product-select"
                                :menu-props="{ contentClass: 'app-setting-field-menu rk-saas-settings__product-menu' }"
                              >
                                <template v-slot:selection="{ item }">
                                  <span class="rk-saas-settings__product-selection" :title="item.text">
                                    {{ item.text }}
                                  </span>
                                </template>
                              </v-select>
                            </div>
                          </div>
                        </v-form>

                        <div class="rk-saas-settings__actions">
                          <v-btn test-tag="tag-306"
                            class="rk-saas-settings__action-btn"
                            block
                            color="warning"
                            outlined
                            :loading="any_loading"
                            :disabled="any_loading"
                            @click="updateInstanceGuid"
                          >
                            {{ $t('Перегенерировать instance') }}
                          </v-btn>

                          <v-btn test-tag="tag-307"
                            class="rk-saas-settings__action-btn"
                            block
                            color="primary"
                            outlined
                            :loading="any_loading"
                            :disabled="any_loading"
                            @click="updateSequenceNumber"
                          >
                            {{ $t('Синхронизировать последовательность') }}
                          </v-btn>
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="12" lg="5" class="saas-layout-col">
                      <v-card
                        elevation="0"
                        class="license-status-card license-status-card--side"
                        :style="{ backgroundColor: licenseStatusColor }"
                      >
                        <v-card-title test-tag="tag-315" class="license-status-title">
                          {{ $t('Информация о лицензии') }}
                        </v-card-title>
                        <v-card-text class="license-status-body">
                          <table class="license-info-table">
                            <tbody>
                              <tr v-for="row in licenseInfoRows" :key="row.label">
                                <td class="license-info-label">{{ row.label }}</td>
                                <td class="license-info-value" :class="row.valueClass">{{ row.value }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-dialog v-model="show_error" max-width="360px">
                    <v-card>
                      <v-card-title test-tag="tag-316">{{ $t('SaaS XML') }}</v-card-title>
                      <v-card-text>{{ error }}</v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn test-tag="tag-308" text color="primary" @click="error = ''">Ok</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import settings_group_mixin from '../settings_group_mixin'

import {mapGetters} from 'vuex'

export default {
  mixins: [settings_group_mixin],
  props:['use_tcp'],
  data: () => ({
    saasXmlMenuOpened: false,
    local_loading: false,
    user: '',
    password: '',
    product_guid: '',

    value: 0,

    viewerOpen: false,
    zoom: 1,
    panX: 0,
    panY: 0,
    dragging: false,
    dragStartX: 0,
    dragStartY: 0,
    panStartX: 0,
    panStartY: 0,
    lastTouchDistance: 0,
    
    showpwd: false,
    show_error: false,
    error: '',
  }),
  async mounted() {
    await this.loadSaasData();
  },
  computed: {
    ...mapGetters(['saas_data']),
    any_loading(){
      return this.local_loading || this.loading;
    },
    licenseModeItems() {
      return [
        {
          text: this.optionLabel('R-Keeper модуль XML сохранение заказов'),
          value: false,
        },
        {
          text: this.optionLabel('R-Keeper модуль XML-интерфейс для приложения'),
          value: true,
        },
      ]
    },

    minZoom() {
      return 0.5
    },
    maxZoom() {
      return 4
    },
    imageStyle() {
      return {
        transform: `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`,
      }
    },

    saas_xml_types(){
      if (this.saas_data.product_guid_reference) {
        return Object.entries(this.saas_data.product_guid_reference).map(([key, value]) => ({text: value, value: key})).filter(el => el.value === '310bc5c7-b0ca-4790-bdeb-afe0d9cf516b' || el.value === 'c4fc346f-df29-4083-b611-49eb275544e8')
      } else return []
    },
    dealerUserLabel() {
      const base = this.$t('Логин')
      if (this.saas_data.credentials) {
        return `${base} (${this.$t('Задан')})`
      }
      return base
    },
    dealerPassLabel() {
      const base = this.$t('Пароль')
      if (this.saas_data.credentials) {
        return `${base} (${this.$t('Задан')})`
      }
      return base
    },
    dealerCredentialsPlaceholder() {
      if (!this.saas_data.credentials) return ''
      return `*${this.$t('Задан')}*`
    },
    licenseStatusColor() {
      if (this.saas_data.license_error) return '#FFCDD2'
      if (this.saas_data.credentials) return '#C8E6C9'
      return '#FFF9C4'
    },
    licenseInfoRows() {
      return [
        {
          label: this.$t('Instance GUID'),
          value: this.saas_data.instance_guid || '—',
          valueClass: '',
        },
        {
          label: this.$t('Данные пользователя l.ucs.ru'),
          value: this.saas_data.credentials
            ? this.$t('Заданы')
            : this.$t('Не заданы'),
          valueClass: this.saas_data.credentials ? 'license-value--ok' : 'license-value--warn',
        },
        {
          label: this.$t('Дата окончания SaaS XML лицензии'),
          value: '—',
          valueClass: '',
        },
        {
          label: this.$t('Ошибка сервера l.ucs.ru'),
          value: this.saas_data.license_error || this.$t('Ошибок нет'),
          valueClass: this.saas_data.license_error ? 'license-value--error' : 'license-value--ok',
        },
      ]
    },
  },
  watch: {
    local_config: {
      handler(val) {
        if (val.use_saas === true) {
          this.loadSaasData()
        }
      },
      deep: true
    },

    error(val) {
      this.show_error = !!val
    },
  },
  methods: {
    async loadSaasData(){
      this.local_loading = true 
      try {
        await this.$store.dispatch('loadSaasData')
        this.product_guid = this.saas_data.product_guid
      } catch (e) {
        this.local_config = {...this.local_config, use_saas: false}
      } finally {
        this.local_loading = false
      }
    },
    submit() {
      return this.saveCredentials(); 
    },
    async saveCredentials(){
      if (!this.user || !this.password || !this.product_guid) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Пожалуйста, заполните все поля.'),
          message_class: 'error'
        })
        return
      }
      
      this.local_loading = true 
      try {
        await this.$store.dispatch('updateSaasData', {user: this.user, password: this.password, product_guid: this.product_guid})
        this.product_guid = this.saas_data.product_guid

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    async updateInstanceGuid(){
      this.local_loading = true
      try {
        await this.$store.dispatch('updateInstanceGuid')

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Идентификатор экземпляра ПО обновлен'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    async updateSequenceNumber(){
      this.local_loading = true
      try {
        await this.$store.dispatch('updateSequenceNumber')

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Порядковый номер запроса обновлен'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    optionLabel(key) {
      return this.$t(key).replace(/<br\s*\/?>/gi, ' ')
    },

    openViewer() {
      this.resetView()
      this.viewerOpen = true
    },
    closeViewer() {
      this.viewerOpen = false
      this.endPan()
    },
    resetView() {
      this.zoom = 1
      this.panX = 0
      this.panY = 0
    },
    zoomIn() {
      this.zoom = Math.min(this.maxZoom, +(this.zoom + 0.15).toFixed(2))
    },
    zoomOut() {
      this.zoom = Math.max(this.minZoom, +(this.zoom - 0.15).toFixed(2))
      if (this.zoom === 1) {
        this.panX = 0
        this.panY = 0
      }
    },
    onWheel(event) {
      if (event.deltaY < 0) {
        this.zoomIn()
      } else {
        this.zoomOut()
      }
    },
    startPan(event) {
      if (this.zoom <= 1) return
      this.dragging = true
      this.dragStartX = event.clientX
      this.dragStartY = event.clientY
      this.panStartX = this.panX
      this.panStartY = this.panY
    },
    onPan(event) {
      if (!this.dragging) return
      this.panX = this.panStartX + (event.clientX - this.dragStartX)
      this.panY = this.panStartY + (event.clientY - this.dragStartY)
    },
    endPan() {
      this.dragging = false
      this.lastTouchDistance = 0
    },
    startTouch(event) {
      if (event.touches.length === 2) {
        this.lastTouchDistance = this.touchDistance(event.touches)
        return
      }
      if (event.touches.length === 1 && this.zoom > 1) {
        this.dragging = true
        this.dragStartX = event.touches[0].clientX
        this.dragStartY = event.touches[0].clientY
        this.panStartX = this.panX
        this.panStartY = this.panY
      }
    },
    onTouch(event) {
      if (event.touches.length === 2) {
        const distance = this.touchDistance(event.touches)
        if (this.lastTouchDistance) {
          const delta = distance - this.lastTouchDistance
          if (delta > 5) this.zoomIn()
          if (delta < -5) this.zoomOut()
        }
        this.lastTouchDistance = distance
        return
      }
      if (this.dragging && event.touches.length === 1) {
        this.panX = this.panStartX + (event.touches[0].clientX - this.dragStartX)
        this.panY = this.panStartY + (event.touches[0].clientY - this.dragStartY)
      }
    },
    touchDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX
      const dy = touches[0].clientY - touches[1].clientY
      return Math.hypot(dx, dy)
    },
  },
}
</script>

<style>

.app-settings-table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.app-settings-table > .app-setting-row:last-child,
.app-settings-table > .app-settings-table__section:last-child .app-setting-row:last-child {
  border-bottom: none;
}

.app-settings-table .v-select--chips .v-select__selections,
.app-setting-field--outlined.v-select--chips .v-select__selections {
  flex-wrap: wrap;
  gap: 4px;
  min-height: 0 !important;
  padding: 6px 0 !important;
}

.app-settings-table .v-select--chips.v-input--dense .v-chip,
.app-setting-field--outlined.v-select--chips.v-input--dense .v-chip {
  margin: 0 !important;
}

.app-settings-table .v-select--chips.v-text-field--outlined .v-select__slot,
.app-setting-field--outlined.v-select--chips.v-text-field--outlined .v-select__slot {
  min-height: 40px;
  height: auto !important;
}

.rk-license-mode >>> .v-select__selections {
  min-width: 0;
}

.app-settings-table > .app-setting-row:last-child,
.app-settings-table > .app-settings-table__section:last-child .app-setting-row:last-child {
  border-bottom: none;
}

.app-settings-table__section {
  display: contents;
}

.app-setting-row {
  display: flex;
  justify-content: space-between;
  gap: 20px 32px;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
}

.app-setting-row--highlight {
  background: rgba(255, 193, 7, 0.12);
  box-shadow: inset 0 0 0 2px rgba(255, 193, 7, 0.55);
}

.app-setting-row--highlight .app-setting-row__label {
  color: rgba(0, 0, 0, 0.92);
}

.app-setting-row--disabled .app-setting-row__label,
.app-setting-row--disabled .app-setting-row__hint-icon {
  color: rgba(0, 0, 0, 0.38) !important;
}

.app-settings-table > .app-setting-row:last-child,
.app-settings-table > .app-settings-table__section:last-child .app-setting-row:last-child {
  border-bottom: none;
}

.app-setting-row--full {
  grid-column: 1 / -1;
}

.app-setting-row--full.app-setting-row--stacked {
  grid-template-columns: 1fr;
}

.app-setting-row--locked .v-input--selection-controls__input {
  opacity: 0.65;
}

.app-setting-row--locked .v-input--switch__thumb {
  color: #bdbdbd !important;
}

.app-setting-row--locked .v-input--switch__track {
  color: #e0e0e0 !important;
}

.app-settings-provider-panel__body .app-setting-row {
  padding-left: 16px;
  padding-right: 16px;
  border-bottom-color: #e8edf3;
  background: transparent;
}

.app-settings-provider-panel__body .app-setting-row:first-child {
  padding-top: 8px;
  border-top: none;
}

.app-settings-provider-panel__body .app-setting-row:last-child {
  border-bottom: none;
}

.rk-server-settings__connection-fields >>> .app-setting-row:last-child {
  border-bottom: none;
}

.rk-saas-settings__form >>> .app-setting-row:last-child {
  border-bottom: none;
}

.app-setting-row__label-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
}

.app-setting-row__hint-icon {
  flex-shrink: 0;
  margin-top: 1px;
  color: rgba(0, 0, 0, 0.45) !important;
}

.app-setting-row__label {
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.87);
  min-width: 0;
}

.app-setting-row__info {
  flex: 0 0 auto;
}

.app-setting-row__control {
  width: 100%;
  max-width: 260px;
}

.app-setting-row__control > .v-input,
.app-setting-row__control > div {
  width: 100%;
  max-width: 100%;
}

.app-setting-row__control .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.app-setting-row__control .v-input {
  margin-top: 0;
  padding-top: 0;
}

.app-setting-field-license-type {
  max-width: 350px;
}

.app-setting-field-license-type > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > input {
  display: none;
}

.app-setting-field--outlined {
  width: 100%;
  max-width: 100%;
}

.app-setting-field--outlined .v-input__control {
  width: 100%;
}

.app-setting-field--outlined input,
.app-setting-field--outlined textarea {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.app-setting-field--outlined.v-textarea textarea {
  white-space: pre-wrap !important;
  line-height: 1.5;
  overflow-y: auto !important;
}

.app-setting-field--outlined.v-text-field--outlined input {
  text-overflow: clip;
}

.app-setting-field--outlined.v-text-field--outlined,
.app-setting-field--outlined.v-select--outlined,
.app-setting-field--outlined.v-autocomplete--outlined {
  margin-top: 0;
  padding-top: 0;
}

.app-setting-field--outlined .v-select__selection,
.app-setting-field--outlined .v-select__selections {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.app-settings-table .v-select--chips .v-select__selections,
.app-setting-field--outlined.v-select--chips .v-select__selections {
  flex-wrap: wrap;
  gap: 4px;
  min-height: 0 !important;
  padding: 6px 0 !important;
}

.app-settings-table .v-select--chips.v-input--dense .v-chip,
.app-setting-field--outlined.v-select--chips.v-input--dense .v-chip {
  margin: 0 !important;
}

.app-settings-table .v-select--chips.v-text-field--outlined .v-select__slot,
.app-setting-field--outlined.v-select--chips.v-text-field--outlined .v-select__slot {
  min-height: 40px;
  height: auto !important;
}

.v-autocomplete__content .v-list-item__title,
.app-setting-field-menu .v-list-item__title,
.v-menu__content .v-list--dense .v-list-item__title {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.app-setting-field-menu--two-line .v-list-item {
  min-height: 56px;
  align-items: flex-start;
  padding-top: 10px;
  padding-bottom: 10px;
}

.app-setting-field-menu--two-line .v-list-item__subtitle {
  font-size: 0.8125rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.55);
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}

.rk-license-mode__menu .v-list-item__title {
  white-space: nowrap;
}

.rk-license-mode__selection {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rk-panel-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app-settings-table__section {
  display: contents;
}

.app-setting-row--nested {
  padding-left: 48px;
}

.section-card {
  background: #fafbfc;
  border-radius: 0px 0px 8px 8px;
  padding: 16px;
  border: 1px solid #e8ecf0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.section-header .section-icon {
  color: #64748b !important;
  margin-right: 8px;
}

.section-title {
  font-size: 1.05rem;
  font-weight: 500;
  min-height: 1.5rem;
}

.lifetime-steps {
  margin: 0;
  padding-left: 20px;
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.5;
}

.lifetime-steps li + li {
  margin-top: 8px;
}

.lifetime-steps >>> a {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.lifetime-steps >>> a:hover {
  text-decoration: underline;
}

.example-panel {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.example-panel-header {
  min-height: 44px !important;
  padding: 10px 16px !important;
  justify-content: center !important;
  background: #f8f9fc;
}

.example-panel-header >>> .v-expansion-panel-header__icon {
  display: none !important;
}

.example-panel-label {
  width: 100%;
  text-align: center;
  font-weight: 600;
  font-size: 0.88rem;
  color: #2d3748;
}

.image-preview {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  cursor: zoom-in;
}

.image-preview:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.image-preview-hint {
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: none;
}

.image-thumb {
  pointer-events: none;
}

.image-viewer-dialog {
  background: transparent;
  box-shadow: none;
}

.image-viewer {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: rgba(0, 0, 0, 0.92);
}

.viewer-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  flex-shrink: 0;
}

.viewer-zoom-label {
  min-width: 48px;
  text-align: center;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 500;
}

.viewer-canvas {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  touch-action: none;
  cursor: default;
}

.viewer-canvas--zoomed {
  cursor: grab;
}

.viewer-image {
  max-width: 95vw;
  max-height: calc(100vh - 64px);
  object-fit: contain;
  transform-origin: center center;
  transition: transform 0.05s linear;
  user-select: none;
}

.viewer-image--dragging {
  cursor: grabbing;
}

.saas-layout-row {
  margin: 0;
}

.saas-layout-col {
  display: flex;
  flex-direction: column;
}

.rk-saas-settings__form {
  width: 100%;
  min-width: 0;
}

.rk-saas-settings__form >>> .app-setting-row:last-child {
  border-bottom: none;
}

.app-settings-server-section-title {
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.87);
}

.rk-saas-settings__product-selection {
  display: block;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
  overflow: visible;
}

.rk-saas-settings__product-menu .v-list-item__title {
  white-space: normal;
  line-height: 1.35;
}

.rk-saas-settings__actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px 20px;
  border-top: 1px solid #e2e8f0;
}

.rk-saas-settings__action-btn {
  min-height: 44px !important;
  height: 44px !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}

.license-status-card {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  width: 100%;
}

.license-status-title {
  font-size: 1rem !important;
  font-weight: 600;
  padding: 16px 16px 8px !important;
  line-height: 1.3;
}

.license-status-body {
  padding: 0 16px 16px !important;
}

.license-info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.license-info-label {
  padding: 10px 12px 10px 0;
  color: #4a5568;
  font-weight: 500;
  width: 42%;
  vertical-align: top;
}

.license-info-value {
  padding: 10px 0;
  color: #1a202c;
  word-break: break-word;
}

.license-value--ok {
  color: #2f855a;
  font-weight: 500;
}

.license-value--warn {
  color: #c05621;
  font-weight: 500;
}

.license-value--error {
  color: #c53030;
  font-weight: 500;
}

@media (max-width: 959px) {
  .app-setting-row {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 14px 16px;
  }

  .app-setting-row--nested {
    padding-left: 32px;
  }

  .app-bar-meta-dialog__table .app-setting-row {
    grid-template-columns: 1fr;
    gap: 6px;
    align-items: start;
  }

  .app-settings-provider-panel__body .app-setting-row {
    padding-left: 12px;
    padding-right: 12px;
  }
}

@media (max-width: 600px) {
  .section-card {
    padding: 12px;
  }
}

@media (min-width: 1264px) {
  .saas-layout-col:first-child {
    border-right: 1px solid #e2e8f0;
  }

  .saas-layout-col:last-child {
    padding: 16px;
  }
}

@media (max-width: 1263px) {
  .saas-layout-col:last-child {
    padding: 16px 0 0;
  }
}

@media (min-width: 1264px) {
  .license-status-card--side {
    height: 100%;
  }
}

@media (min-width: 1264px) {
  .license-status-card--side {
    height: 100%;
  }
}

</style>